/*
 * THE FLYING BEANS — FOUR ORIGINS DISCOVERY SECTION CONTROLLER
 * Isolated ScrollTrigger Entrance & Theme Editor Lifecycle
 * Platform: Shopify 2.0
 */

(function () {
  'use strict';

  window.TFB = window.TFB || {};

  /**
   * Initialize Origins Discovery Section
   */
  function initOriginsSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized === 'true') return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      sectionEl.dataset.initialized = 'true';
      return;
    }

    var cards = sectionEl.querySelectorAll('.tfb-origin-card');
    var header = sectionEl.querySelector('.tfb-origins__header');
    if (!cards.length) return;

    var gsapUrl = sectionEl.dataset.gsapUrl;
    var stUrl = sectionEl.dataset.scrolltriggerUrl;

    // Helper to run animation once GSAP and ScrollTrigger are ready
    function setupAnimation(gsap, ScrollTrigger) {
      sectionEl.dataset.initialized = 'true';

      // Set initial styles safely via GSAP
      gsap.set(cards, {
        y: 40,
        opacity: 0
      });

      if (header) {
        gsap.set(header, {
          y: 25,
          opacity: 0
        });
      }

      // ScrollTrigger for Section Header
      if (header) {
        ScrollTrigger.create({
          trigger: header,
          start: 'top 85%',
          once: true,
          onEnter: function () {
            gsap.to(header, {
              y: 0,
              opacity: 1,
              duration: 0.9,
              ease: 'power2.out'
            });
          }
        });
      }

      // ScrollTrigger for Origin Cards Stagger Entrance
      var grid = sectionEl.querySelector('.tfb-origins__grid') || cards[0];
      ScrollTrigger.create({
        trigger: grid,
        start: 'top 82%',
        once: true,
        onEnter: function () {
          gsap.to(cards, {
            y: 0,
            opacity: 1,
            duration: 0.95,
            stagger: 0.12,
            ease: 'power2.out',
            clearProps: 'transform,opacity'
          });
        }
      });
    }

    // Load GSAP via singleton or existing globals
    if (window.gsap && window.ScrollTrigger) {
      setupAnimation(window.gsap, window.ScrollTrigger);
    } else if (typeof window.TFB.loadGSAP === 'function' && gsapUrl && stUrl) {
      window.TFB.loadGSAP(gsapUrl, stUrl)
        .then(function (ctx) {
          setupAnimation(ctx.gsap || window.gsap, ctx.ScrollTrigger || window.ScrollTrigger);
        })
        .catch(function (err) {
          console.warn('[TFB Origins] GSAP load failed, falling back to default styles:', err);
          cards.forEach(function (card) {
            card.style.opacity = '1';
            card.style.transform = 'none';
          });
        });
    }
  }

  // Auto-init on DOM ready
  function initAllOrigins() {
    var sections = document.querySelectorAll('.tfb-origins');
    sections.forEach(function (sec) {
      initOriginsSection(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllOrigins);
  } else {
    initAllOrigins();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('tfb-origins-section')) {
      var sec = event.target.querySelector('.tfb-origins');
      if (sec) {
        sec.dataset.initialized = 'false';
        initOriginsSection(sec);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.classList.contains('tfb-origins-section')) {
      if (window.ScrollTrigger) {
        var triggers = window.ScrollTrigger.getAll();
        triggers.forEach(function (st) {
          if (event.target.contains(st.trigger)) {
            st.kill(true);
          }
        });
      }
    }
  });

})();
